'use client';

import { useStorageQuotaMonitor } from '@/lib/hooks/useStorageQuotaMonitor';

/**
 * Storage Quota Monitor Component
 *
 * Monitors browser storage quota and displays warnings to users
 * when storage is running low. Works in both development and production.
 *
 * This component should be included at the root level of the application
 * to ensure storage warnings are visible throughout the app.
 */
export default function StorageQuotaMonitor() {
  useStorageQuotaMonitor();
  return null; // This component only handles side effects
}
